import React from 'react';
import PropTypes from 'prop-types';
import FastSwitch from 'components/Switch/FastSwitch';
import TessaraLogo from '../../../components/TessaraLogo';

function VirtualTrayFooter({
  volumeDetailView,
  onVolumeDetailViewChange,
  arrowDetailView,
  onArrowDetailViewChange,
  intl,
  showVolumeDetailView,
  enableDirectionDetailView,
  showDetailButton,
  isTessaraSuperUser,
}) {
  return (
    <div
      className="virtual-tray-footer"
      style={{
        justifyContent: isTessaraSuperUser ? 'space-between' : 'flex-end',
        height: '9%',
      }}
    >
      {isTessaraSuperUser && <TessaraLogo style={{height: '85%'}} />}
      <div className={`virtual-tray-footer-right ${showDetailButton ? '' : 'hide'}`}>
        <div className="detail-view">
          {showVolumeDetailView ? (
            <div className="detail-view-item">
              <span className="text">
                {intl.formatMessage({id: 'protocolEditor.virtualTray.footer.volumeDetailView'})}
              </span>
              <FastSwitch checked={volumeDetailView} onChange={onVolumeDetailViewChange} size="thin" />
            </div>
          ) : (
            <div className="detail-view-item">&nbsp;</div>
          )}
          <div className="detail-view-item">
            <span className="text">
              {intl.formatMessage({id: 'protocolEditor.virtualTray.footer.arrowDetailView'})}
            </span>
            <FastSwitch
              checked={!enableDirectionDetailView ? false : arrowDetailView}
              onChange={onArrowDetailViewChange}
              disabled={!enableDirectionDetailView}
              size="thin"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

VirtualTrayFooter.propTypes = {
  intl: PropTypes.any.isRequired,
  volumeDetailView: PropTypes.bool.isRequired,
  onVolumeDetailViewChange: PropTypes.func.isRequired,
  arrowDetailView: PropTypes.bool.isRequired,
  onArrowDetailViewChange: PropTypes.func.isRequired,
  showVolumeDetailView: PropTypes.bool,
  enableDirectionDetailView: PropTypes.bool,
  showDetailButton: PropTypes.bool,
  isTessaraSuperUser: PropTypes.bool,
};

VirtualTrayFooter.defaultProps = {
  showVolumeDetailView: true,
  enableDirectionDetailView: true,
  showDetailButton: true,
  isTessaraSuperUser: false,
};

const areEqual = (prevProps, nextProps) =>
  prevProps.volumeDetailView === nextProps.volumeDetailView &&
  prevProps.arrowDetailView === nextProps.arrowDetailView &&
  prevProps.showVolumeDetailView === nextProps.showVolumeDetailView &&
  prevProps.enableDirectionDetailView === nextProps.enableDirectionDetailView &&
  prevProps.showDetailButton === nextProps.showDetailButton &&
  prevProps.isTessaraSuperUser === nextProps.isTessaraSuperUser;

export default React.memo(VirtualTrayFooter, areEqual);
